<div class="prf-footer-legal">
  @for (legalItem of legals; track legalItem.id) {
    <prf-footer-legal-item [legal]="legalItem" />
  }
</div>
